"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMakeCodeByName = exports.getMakeNameByCode = exports.MAKE = void 0;
// @ts-ignore
const lodash_1 = require("lodash");
var MAKE;
(function (MAKE) {
    MAKE["Mercedes"] = "MER";
    MAKE["Citroen"] = "CIT";
    MAKE["Kia"] = "KIA";
    MAKE["Peugeot"] = "PEU";
    MAKE["DS"] = "DS";
    MAKE["Smart"] = "SMA";
    MAKE["Opel"] = "OPE";
    MAKE["Fuso"] = "FUS";
})(MAKE = exports.MAKE || (exports.MAKE = {}));
const getMakeNameByCode = (code, extendedNames = false) => {
    switch (code) {
        case MAKE.Mercedes:
            if (extendedNames)
                return 'Mercedes-Benz';
            return 'Mercedes';
        case MAKE.Citroen:
            if (extendedNames)
                return 'Citroën';
            return 'Citroen';
        case MAKE.Kia:
            return 'Kia';
        case MAKE.Peugeot:
            return 'Peugeot';
        case MAKE.DS:
            // if (extendedNames) return 'DS Automobiles';
            return 'DS';
        case MAKE.Smart:
            return 'Smart';
        case MAKE.Opel:
            return 'Opel';
        case MAKE.Fuso:
            return 'Fuso';
        default:
            return null;
    }
};
exports.getMakeNameByCode = getMakeNameByCode;
const getMakeCodeByName = (make) => {
    if (typeof make != 'string') {
        return null;
    }
    switch ((0, lodash_1.deburr)(make).toLowerCase()) {
        case 'mercedes-benz':
        case 'mercedes':
        case 'mer':
            return MAKE.Mercedes;
        case 'citroen':
        case 'cit':
            return MAKE.Citroen;
        case 'kia':
            return MAKE.Kia;
        case 'peugeot':
        case 'peu':
            return MAKE.Peugeot;
        case 'ds-automobiles':
        case 'ds':
            return MAKE.DS;
        case 'smart':
        case 'sma':
            return MAKE.Smart;
        case 'opel':
        case 'ope':
            return MAKE.Opel;
        case 'fuso':
        case 'fus':
            return MAKE.Fuso;
        default:
            return null;
    }
};
exports.getMakeCodeByName = getMakeCodeByName;
//# sourceMappingURL=make.js.map